import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";
import React from "react";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

class Firebase {
  constructor() {
    firebase.initializeApp(firebaseConfig);
    this.auth = firebase.auth;
    this.fs = firebase.firestore;
    this.db = firebase.database;
    this.strg = firebase.storage;
    this.strg().setMaxUploadRetryTime(30000);
  }
  signUp = (email, password) =>
    this.auth().createUserWithEmailAndPassword(email, password);

  signIn = (email, password) =>
    this.auth().signInWithEmailAndPassword(email, password);

  signOut = () => this.auth().signOut();

  resetPW = email => this.auth().sendPasswordResetEmail(email);

  changePW = password => this.auth().currentUser.updatePassword(password);

  getUser = () => this.auth().currentUser;
}

export const FirebaseContext = React.createContext(null);
export default Firebase;
